import { Component, Input, OnInit } from '@angular/core';
import { AnalyticsService } from '../../../../_services';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-profileanalysisnode',
  templateUrl: './profileanalysisnode.component.html',
  styleUrls: ['./profileanalysisnode.component.css']
})
export class ProfileanalysisnodeComponent implements OnInit {
  @Input('details') details: any;
  @Input('full_analytics') full_analytics: any;
  response: any;
  lender_id: any;
  borrower_id: any;
  principal: any;
  maturity_date: any;
  account_card_id: any;
  loan_request_id: any;
  card_id: any;
  passed_analytics: any;
  failed_analytics: any;
  number_passed: number;
  number_failed: number;
  constructor(
    private analyticsService: AnalyticsService,
    private http: HttpClient
  ) {
    //console.log(this.full_analytics);
  }

  ngOnInit() {
    // this.getAnalytics();
    // //console.log(this.full_analytics);
  }
  // getAnalytics() {
  //   //   return new Promise((resolve, reject) => {
  //   //     return this.http
  //   //       .post<any>(`https://eligibilitytest.creditclan.com/public/requestparams`, {
  //   //         request_id: '13126'
  //   //       })
  //   //       .toPromise()
  //   //       .then(res => {
  //   //         //console.log(res);
  //   //         this.lender_id = res.lender_id;
  //   //         this.borrower_id = res.borrower_id;
  //   //         this.principal = res.principal;
  //   //         this.maturity_date = res.maturity_date;
  //   //         this.account_card_id = res.account_card_id;
  //   //         this.loan_request_id = res.loan_request_id;
  //   //         this.card_id = res.card_id;
  //   //         resolve();
  //   //       })
  //   //       .then(() => this.getFullAnalytics())
  //   //       .catch(err => {
  //   //         //console.log(err);
  //   //         // reject();
  //   //       });
  //   //   });
  //   // }
  //   // getFullAnalytics() {
  //   //   //console.log(this.lender_id);
  //   //   return this.analyticsService
  //   //     .getFullAnalytics(
  //   //       this.lender_id,
  //   //       this.borrower_id,
  //   //       this.principal,
  //   //       this.maturity_date,
  //   //       this.account_card_id,
  //   //       this.loan_request_id,
  //   //       this.card_id
  //   //     )
  //   //     .subscribe(data => {
  //   //       this.passed_analytics = data.description.profile.passed;
  //   //       this.failed_analytics = data.description.profile.failed;
  //   //       this.number_passed = this.passed_analytics.length;
  //   //       this.number_failed = this.failed_analytics.length;
  //   //     });
  //   // }
}
